import React, { useState, useEffect } from 'react';
import { useRouter } from '../../components';
//import { navigate, usePath, useLocationChange } from 'raviger';
import { SiteLink } from '../../components';
import { NavBar } from './navBar';
import { FaAngleLeft } from 'react-icons/fa';
import { useHistory } from '../../components';
import utils from '../../utils';
import { getTippingCompId } from '../../site/tipping/tippingCommon';

export function TopHeader(props) {

  const { pathname, path } = useRouter();
  const [menuOpened, setMenuOpened] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(pathname);

  const history = useHistory(pathname);

  const routeChanged = (path, history) => {
    //console.log(path, history);
    //console.log(window.location.hash)
    if (typeof window !== `undefined`) {
	    const hash = window.location.hash;
	    const search = window.location.search;
	    history.push(path + hash + search)
	
	    if (hash) { scrollTo(); }
	  }
  }


  useEffect(() => {
    routeChanged(pathname, history);
    setCurrentLocation(pathname);
    // eslint-disable-next-line
  }, [pathname]);

  function scrollTo() {
    const hash = window.location.hash;
    if (hash) {
      //console.log(hash)
      setTimeout(() => {
        const anchor = utils.ui.findElement(hash);
        if (anchor)
          utils.ui.scrollTo(anchor, 500);
      }, 500)
    }
  }

  function toggleMenu(e) {
    setMenuOpened(!menuOpened);
  }

  function onCloseMenu() {
    setMenuOpened(false);
  }

  function goBack(e) {
    //e.preventDefault();
    history.getPrevious();
    //console.log(previousLink)
  }

  // useEffect(() => {
  //   console.log('use history')
  // }, []);

  const compId = getTippingCompId();
  const pathFiltered = (path || '').toLocaleLowerCase();
  let specialClassName = '';
  if (pathFiltered.indexOf('/wanderers') >= 0 ||
  pathFiltered.indexOf('comp=14') >= 0 ||
  (pathFiltered.indexOf('/tipping/') >= 0 && compId === '14')) specialClassName = 'wanderers';

  return (
    <>
      <header className={`topNav`}  id="top">
        {
          history.history.length > 1 && 
          <SiteLink className="topNav__back" title="Go Back" to={history.getPreviousPath()} onClick={goBack} >
            <FaAngleLeft /> BACK
          </SiteLink>
        } 
        
        {/* <div className="topNav__skewBar"></div> */}
        <SiteLink to="/" className="topNav__logo logo1">
          <img src="/assets/logos/logo.png" alt="logo" />
        </SiteLink >
        <SiteLink to="/" className="topNav__logo logo2">
          <img src="/assets/logos/logo2.png" alt="logo" />
        </SiteLink >

        {specialClassName === 'wanderers' &&
        <SiteLink to="/tipping/wanderers" className="topNav__logo">
        Wanderers
        </SiteLink >
        }
        {/* <div className = "topNav__roundBg"></div> */}
        <button id="mobile-menu-icon" type="button" aria-label="Menu" className={`hamburger hamburger--collapse ${menuOpened ? 'is-active' : ''}`} onClick={toggleMenu}>
          <span className="hamburger-box">
            <span className="hamburger-inner">
            </span>
          </span>
        </button>

        <NavBar open={menuOpened} onCloseMenu={onCloseMenu} currentLocation={currentLocation}></NavBar>
      </header>
    </>
  );
}